import script from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalTokenSelect.vue?vue&type=style&index=0&id=77dd99e1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77dd99e1"]])

export default __exports__